import React, { useState } from 'react';

import { Modal, Button, Alert, Row, Col, Select, Icon } from '../../../../core/ui';
import { useTranslation } from '../../../../core/context/TranslationContext';

import { downloadAccountantExport } from '../../api/reports';
import styles from './AccountantExportModal.module.css';

const MONTH_KEYS = [
  'monthJanuary', 'monthFebruary', 'monthMarch', 'monthApril', 'monthMay', 'monthJune',
  'monthJuly', 'monthAugust', 'monthSeptember', 'monthOctober', 'monthNovember', 'monthDecember',
];

/** Monthly Excel export of receipts for an accountant, opened from the receipt list. */
export default function AccountantExportModal({ open, onClose }) {
  const { t } = useTranslation();
  const currentDate = new Date();
  const [year, setYear] = useState(currentDate.getFullYear());
  const [month, setMonth] = useState(currentDate.getMonth() + 1);
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  const years = [];
  for (let y = currentDate.getFullYear(); y >= 2020; y--) {
    years.push(y);
  }

  const handleDownload = async () => {
    try {
      setDownloading(true);
      setError(null);
      await downloadAccountantExport(year, month);
    } catch (err) {
      console.error('Accountant export failed', err);
      setError(t('accountantExportError'));
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('accountantExport')}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>{t('cancel')}</Button>
          <Button onClick={handleDownload} disabled={downloading}>
            <Icon name="fa-download" size="sm" />
            {downloading ? t('accountantExportDownloading') : t('accountantExportButton')}
          </Button>
        </>
      }
    >
      <p className={styles.description}>{t('accountantExportDescription')}</p>
      {error && (
        <Alert variant="danger" dismissible onDismiss={() => setError(null)}>
          {error}
        </Alert>
      )}
      <Row gutter="md">
        <Col span={6}>
          <Select label={t('selectYear')} value={year} onChange={(e) => setYear(parseInt(e.target.value, 10))}>
            {years.map((y) => (
              <option key={y} value={y}>{y}</option>
            ))}
          </Select>
        </Col>
        <Col span={6}>
          <Select label={t('selectMonth')} value={month} onChange={(e) => setMonth(parseInt(e.target.value, 10))}>
            {MONTH_KEYS.map((key, i) => (
              <option key={key} value={i + 1}>{t(key)}</option>
            ))}
          </Select>
        </Col>
      </Row>
    </Modal>
  );
}
